import { render } from "./ModalNewInc.vue?vue&type=template&id=3e82768c"
import script from "./ModalNewInc.vue?vue&type=script&lang=js"
export * from "./ModalNewInc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__